import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import styles from './styles';

const MobileSelectEditInputTextField = (props) => {
  const { id, value = '', field, updateData, numberFormatOnly, loading } = props;
  const classes = styles();

  const handleChange = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    const newValue = event.target.value;
    const isValidNumber = /^-?\d*\.?\d*$/.test(newValue);
    if (!numberFormatOnly || isValidNumber) {
      updateData(id, field, newValue);
    }
  };

  return (
     <TextField
     sx={{
       '.MuiInputBase-input': {
         padding: '10px',
         textAlign: 'center',
         fontWeight: 900
       }
     }}
      id={`signal-textfield-${id}`}
      variant="filled"
      value={value}
      onChange={handleChange}
      fullWidth
      className={classes.inputField}
      InputProps={{
        disableUnderline: true,
      }}
      disabled={loading}
    />
  );
};

MobileSelectEditInputTextField.propTypes = {
  field: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  value: PropTypes.any,
  updateData: PropTypes.func,
  closeCellAfterSelect: PropTypes.any,
  numberFormatOnly: PropTypes.any,
  loading: PropTypes.any
};

export default MobileSelectEditInputTextField;
